import apiClient from '../middleware/apiClient';
import {
  COTTON_DEVICE_STATUS,
  DEVICE_STATUS,
} from '../helpers/apis';
import { callApiWithFallback } from '../helpers/apiFallback';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { kibanaLog } from '../helpers/logger';

export const FETCH_DEVICE_STATUS = 'FETCH_DEVICE_STATUS';
export const FETCH_DEVICE_STATUS_SUCCESS = 'FETCH_DEVICE_STATUS_SUCCESS';
export const FETCH_DEVICE_STATUS_FAILURE = 'FETCH_DEVICE_STATUS_FAILURE';

function dispatchGetDeviceStatus(endpoint = DEVICE_STATUS) {
  return {
    type: FETCH_DEVICE_STATUS,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetDeviceStatusSuccess(payload) {
  return {
    type: FETCH_DEVICE_STATUS_SUCCESS,
    payload,
  };
}

function dispatchGetDeviceStatusFailure(error) {
  return {
    type: FETCH_DEVICE_STATUS_FAILURE,
    payload: error,
  };
}

export const getDeviceStatus = () => async (dispatch, getState) => {
  const { deviceStatus = {} } = getState();
  if (deviceStatus.requested) {
    return null;
  }

  try {
    let response;
    const { isAptV1Enabled, deviceStatusApiEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_device_status_api_called');
      response = await dispatch(dispatchGetDeviceStatus(COTTON_DEVICE_STATUS)).payload;
    } else if (deviceStatusApiEnabled) {
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetDeviceStatus(COTTON_DEVICE_STATUS),
        () => dispatchGetDeviceStatus(DEVICE_STATUS),
        'device_status',
      );
    } else {
      // Only call Ruby API
      response = await dispatch(dispatchGetDeviceStatus(DEVICE_STATUS)).payload;
    }

    return dispatch(dispatchGetDeviceStatusSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetDeviceStatusFailure(error));
  }
};
